import React from "react";
import { Alert } from "antd";

const isSafariBrowser = () => {
  const ua = navigator.userAgent;
  return /^((?!chrome|android|crios|fxios|edg).)*safari/i.test(ua);
};

const getUnsupportedBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();

  if (ua.includes("firefox")) {
    return "Firefox";
  }

  if (isSafariBrowser()) {
    return "Safari";
  }

  return null;
};

const PwaInstallSupportNotice = () => {
  const unsupportedBrowser = getUnsupportedBrowser();

  if (!unsupportedBrowser) {
    return null;
  }

  return (
    <Alert
      style={{ marginBottom: 16, textAlign: "left" }}
      showIcon
      type="info"
      message={`Limited PWA install support on ${unsupportedBrowser}`}
      description="This browser may not show the app install prompt. For the best install experience, open this page in Chrome or Edge."
    />
  );
};

export default PwaInstallSupportNotice;